import Raven from 'raven-js';
import enviro from 'enviro';
import { ACH, AFFIRM, BACS, KLARNA, PADS, SEPA } from 'payments-checkout-lib/constants/PaymentElement';
import { RECAPTCHA_ACH_TYPE, RECAPTCHA_AFFIRM_TYPE, RECAPTCHA_BACS_TYPE, RECAPTCHA_CARD_TYPE, RECAPTCHA_KLARNA_TYPE, RECAPTCHA_PADS_TYPE, RECAPTCHA_SEPA_TYPE } from '../constants/ReCaptcha';
import { trackRecaptchaFailureOrBlocked } from './tracking';
const TEST_SITE_KEY = '6Le6rD8kAAAAAFAKCOH96PLU8P5WE1RWz5Sz5Quh';
const PROD_SITE_KEY = '6LdZL7wkAAAAAJ8fv2_ZtTKDmr22AeNATST8naKi';
const GOOGLE_RECAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/enterprise.js';
const FALLBACK_SCRIPT_URL = 'https://recaptcha.net/recaptcha/enterprise.js';
export function addRecaptchaScript(isATPortal) {
  const isQA = enviro.isQa();
  const siteKey = isQA || isATPortal ? TEST_SITE_KEY : PROD_SITE_KEY;
  const script = createRecaptchaScript({
    src: GOOGLE_RECAPTCHA_SCRIPT_URL,
    siteKey,
    onError: () => {
      createRecaptchaScript({
        src: FALLBACK_SCRIPT_URL,
        siteKey,
        onError: e => {
          throw e;
        }
      });
    }
  });
  document.head.appendChild(script);
}
function createRecaptchaScript({
  src,
  siteKey,
  onError
}) {
  const script = document.createElement('script');
  script.async = true;
  script.type = 'text/javascript';
  script.src = `${src}?render=${siteKey}`;
  script.onerror = onError;
  return script;
}
const getActionType = paymentMethod => {
  switch (paymentMethod) {
    case ACH:
      return RECAPTCHA_ACH_TYPE;
    case BACS:
      return RECAPTCHA_BACS_TYPE;
    case PADS:
      return RECAPTCHA_PADS_TYPE;
    case SEPA:
      return RECAPTCHA_SEPA_TYPE;
    case AFFIRM:
      return RECAPTCHA_AFFIRM_TYPE;
    case KLARNA:
      return RECAPTCHA_KLARNA_TYPE;
    default:
      return RECAPTCHA_CARD_TYPE;
  }
};
export const submitPaymentWithRecaptcha = (isATPortal, submitPayment, paymentMethod) => {
  const isQA = enviro.isQa();
  const siteKey = isQA || isATPortal ? TEST_SITE_KEY : PROD_SITE_KEY;
  const action = getActionType(paymentMethod);
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      Raven.captureMessage(`window.grecaptcha failed to load, submitting payment with null token`);
      resolve(submitPayment(null));
    }
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(siteKey, {
        action
      }).then(recaptchaToken => {
        submitPayment(recaptchaToken);
      }).catch(err => {
        const errorMessage = `The grecaptcha.enterprise.execute failed with error: ${err}`;
        Raven.captureMessage(errorMessage);
        trackRecaptchaFailureOrBlocked();
        reject(errorMessage);
      });
    });
  });
};
export const getIsRecaptchaEnabled = checkoutSession => checkoutSession.get('liveMode') && checkoutSession.getIn(['checkoutIntegrations', 'recaptchaIntegration', 'isEnabled']);